module.exports = __webpack_public_path__ + "img/grouping.16ad9401.svg";